// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItensStatus_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/menu_itens_status/salvar
 *
 * Create or update a menu item status. If menu_item_status_id is provided and > 0, updates existing record.
 */
import { registerContract } from './validate'

export interface MenuItensStatus_SalvarInput {
menu_item_status_titulo: string
menu_item_status_id?: number
}

registerContract('MenuItensStatus_SalvarInput', {
  menu_item_status_titulo: { type: 'string',  required: true },
  menu_item_status_id:     { type: 'number',  required: false },
})
